import {
  Carousel,
  Popover,
  Tooltip,
} from "bootstrap";

function InitTooltips() {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((tooltip) => {
    return new Tooltip(tooltip);
  });
}

function InitPopovers() {
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((popover) => {
    return new Popover(popover);
  });
}

function InitCarousel() {
  document.querySelectorAll('[data-init-carousel]').forEach((c) => {
    const carousel = c as HTMLElement;

    let interval = 2000;
    if (carousel.dataset.carouselInterval) {
      interval = parseInt(carousel.dataset.dataCarouselInterval as string);

      if (interval < 200 || interval > 10_000) {
        throw new Error("Carousel interval must be between 200 and 10_000 inclusive")
      }
    }

    let touch = false;
    if (carousel.dataset.carouselTouch) {
      touch = true;
    }

    return new Carousel(carousel, { touch: touch, interval: interval });
  });
}

const Helpers = {
  InitTooltips,
  InitPopovers,
  InitCarousel,
};

export default Helpers;
